import Media from "./services/media.service";
import {Logger} from "./services/logger.service";
import {Notifications} from "./services/notification.service";
import {Orders} from "./services/order.service";
import {Order} from "./prototypes/order.prototype";
import {Constants} from "./services/constants.service";
import {Polling} from "./services/polling.service";
import pims from './index.module.ajs';
import Utils from "./services/utils.service";
import Auth from "./services/auth.service";
import angular from "angular";
import Photos from "./services/photos.service";
import {Users} from "./services/user.service";

export function loggerServiceFactory(i: any) {
  return i.get('Logger');
}
export const loggerServiceProvider = {
  provide: Logger,
  useFactory: loggerServiceFactory,
  deps: ['$injector']
}
export function mediaServiceFactory(i: any) {
  return i.get('Media');
}
export const mediaServiceProvider = {
  provide: Media,
  useFactory: mediaServiceFactory,
  deps: ['$injector']
}
export function notificationServiceFactory(i: any) {
  return i.get('Notifications');
}
export const notificationServiceProvider = {
  provide: Notifications,
  useFactory: notificationServiceFactory,
  deps: ['$injector']
}
export function orderServiceFactory(i: any) {
  return i.get('Orders');
}
export const ordersServiceProvider = {
  provide: Orders,
  useFactory: orderServiceFactory,
  deps: ['$injector']
}
export function orderPrototypeServiceFactory(i: any) {
  return i.get('Order');
}
export const ordersPrototypeServiceProvider = {
  provide: Order,
  useFactory: orderPrototypeServiceFactory,
  deps: ['$injector']
}
export function constantsServiceFactory(i: any) {
  return i.get('Constants');
}
export const constantsServiceProvider = {
  provide: Constants,
  useFactory: constantsServiceFactory,
  deps: ['$injector']
}
export function pollingServiceFactory(i: any) {
  return i.get('Polling');
}
export const pollingServiceProvider = {
  provide: Polling,
  useFactory: pollingServiceFactory,
  deps: ['$injector']
}

export function utilsServiceFactory(i: any) {
  return i.get('Utils');
}

export const utilsServiceProvider = {
  provide: Utils,
  useFactory: utilsServiceFactory,
  deps: ['$injector']
};

export function authServiceFactory(i: any) {
  return i.get('Auth')
}

export const authServiceProvider = {
  provide: Auth,
  useFactory: authServiceFactory,
  deps: ['$injector']
}

export function photosServiceFactory(i: any) {
  return i.get('Photos')
}

export const photoServiceProvider = {
  provide: Photos,
  useFactory: photosServiceFactory,
  deps: ['$injector']
}

export function usersServiceFactory(i:any) {
  return i.get('Users')
}

export const usersServiceProvider = {
  provide: Users,
  useFactory: usersServiceFactory,
  deps: ['$injector']
}

export const $rootScopeProvider = {
  provide: '$rootScope',
  useFactory: (i: any) => i.get('$rootScope'),
  deps: ['$injector']
  }


export const $scopeProvider = {
		provide: '$scope',
		useFactory: (i: any) => i.get('$rootScope').$new(),
		deps: ['$injector']
	  }
  

export function loadUpgradedServices() {
  pims.service('Media', Media)
    .service('Constants', Constants)
    .factory('Notifications', Notifications)
    .service('Polling', Polling)
    .service('Orders', Orders)
    .factory('Logger', Logger)
    .service('Utils', Utils)
    .service('Auth', Auth)
    .service('Photos', Photos)
    .service('Users', Users)
}
